import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import React, { Fragment } from 'react';
import translationsUI from '../view/ui/translationUI';
import { NETWORK_STATUS } from '~/utils/config';

const SocketProvider = (props) => {
  const intl = useIntl();
  const { netWorkStatus } = props;
  const backOnline = intl.formatMessage(translationsUI.PAVE_ONLINE_BACK);
  const offline = intl.formatMessage(translationsUI.PAVE_LOST_CONNECTION);
  return (
    <Fragment>
      <Fragment>{props.children}</Fragment>

      {netWorkStatus && (
        <div
          style={{
            width: '100%',
            position: 'fixed',
            top: '0',
            zIndex: '10000001',
            // height: '15px',
          }}
        >
          <div
            className="animate-bottom"
            style={{
              textAlign: 'center',
              display: 'block',
              fontSize: '12px',
              color: '#fff',
              background: `${
                netWorkStatus === 'ONLINE'
                  ? 'green'
                  : netWorkStatus === NETWORK_STATUS.OFFLINE
                  ? 'red'
                  : 'transparent'
              }`,
            }}
          >
            {netWorkStatus === 'ONLINE'
              ? backOnline
              : netWorkStatus === NETWORK_STATUS.OFFLINE
              ? offline
              : ''}
          </div>
        </div>
      )}
    </Fragment>
  );
};
const mapStateToProps = (state) => ({
  netWorkStatus: state.userDetailsReducer.defaultNetWork,
});
export default connect(mapStateToProps, null)(SocketProvider);
